// extracted by mini-css-extract-plugin
module.exports = {"edit-ranking-title":"edit-ranking-title-90ec8b05c4fad009d3a5ea85949fcb43","edit-ranking-button":"edit-ranking-button-db4354bf24c3cd247a592263576ad9be"};